import { compact } from 'lodash';

export function tokenize(str: string): string[] {
    return str.length ? compact(str.toLowerCase().split(/[\s,]+/)) : [];
}
